import { getInitialBoolean, getInitialNumber } from "@/shared/lib/localStorage";
import { useEffect, useState } from "react";
import { useDashboardActions } from "../../../lib/useDashboardActions";
import { useDashboard } from "../../../lib/useDashboard";
import { useAuth } from "@/features/Auth/lib/useAuth";
import { usePlan } from "@/entities/Plan";
import { ObjectTopItem } from "../_shared/ObjectTop/ObjectTop";
import { MainTypesPlans } from "../../../model/dashboard.types";

const useTopDepartments = () => {
  const LS_IS_PERIOD_KEY = 'topDepartments_isPeriod';
  const LS_TYPE_ID_KEY = 'topDepartments_typeId';

  const [isPeriod, setIsPeriodState] = useState<boolean>(getInitialBoolean(LS_IS_PERIOD_KEY, false));
  const [typeId, setTypeIdState] = useState<number>(getInitialNumber(LS_TYPE_ID_KEY, 4));
  const [planName, setPlanName] = useState<string>('');
  const [top, setTop] = useState<ObjectTopItem[]>([]);

  useEffect(() => {
    localStorage.setItem(LS_IS_PERIOD_KEY, String(isPeriod));
  }, [isPeriod]);
  useEffect(() => {
    localStorage.setItem(LS_TYPE_ID_KEY, String(typeId));
  }, [typeId]);

  const { 
    loading: dashboardLoading, 
    error: dashboardError, 
    dateStart, dateEnd, 
    dashboardTopDepartments: result,
    setDashboardTopDepartments: setResult
  } = useDashboard();
  const { getTopDepartments } = useDashboardActions();
  const { planTypes } = usePlan();
  const { isAuth } = useAuth();

  useEffect(() => {
    if (isAuth && dateStart && dateEnd) {
      const type = planTypes.find((pt) => pt.id === typeId);
      const apiType =
        type?.code === "MAIN_PROFIT_EMPLOYEE_MONTH"
          ? MainTypesPlans.profit
          : MainTypesPlans.opportunitie;
      getTopDepartments({
        dateStart,
        dateEnd,
        isPeriod,
        type: apiType,
      }).then((result) => {
        setResult(result ?? []);
      });
    }
    // eslint-disable-next-line
  }, [isAuth, dateStart, dateEnd, isPeriod, typeId, planTypes]);

  useEffect(() => {
    const type = planTypes.find(pt => pt.id === typeId);
    if (type && result) {
      let newTop: ObjectTopItem[] = [];
      setPlanName(type.plan_object ?? 'Неизвестный тип плана');

      const getPrecent = (r: { plans?: { opportunity?: { precent?: number }; profit?: { precent?: number }; second?: { code: string; precent?: number }[] }; precent?: number }) => {
        if (r.precent != null) return String(r.precent);
        if (r.plans) {
          if (type.code === 'MAIN_OPPORTUNITY_EMPLOYEE_MONTH') return String(r.plans.opportunity?.precent ?? 0);
          if (type.code === 'MAIN_PROFIT_EMPLOYEE_MONTH') return String(r.plans.profit?.precent ?? 0);
          const secondItem = r.plans.second?.find(s => s.code === type.code);
          return secondItem ? String(secondItem.precent ?? 0).replace(/\s/g, '') : '0';
        }
        return '0';
      };

      if (type.code === 'MAIN_OPPORTUNITY_EMPLOYEE_MONTH' || type.code === 'MAIN_PROFIT_EMPLOYEE_MONTH') {
        newTop = result.map((r, idx) => ({
          id: idx,
          isEmpty: false,
          name: r.name,
          place: idx + 1,
          value: getPrecent(r),
        }));
      } else {
        newTop = result.map((r, idx) => ({
          id: idx,
          isEmpty: false,
          name: r.name,
          place: idx + 1,
          value: getPrecent(r),
        }));
        newTop.sort((a, b) => Number(b.value) - Number(a.value));
        newTop = newTop.map((item, index) => ({
          ...item,
          place: index + 1
        }));
      }

      if (newTop.length > 0) {
        const emptyCount = 5 - newTop.length;
        if (emptyCount > 0) {
          newTop = [
            ...newTop,
            ...Array.from({ length: emptyCount }, (_, i) => ({
              id: -(i + 1),
              isEmpty: true,
              name: '',
              place: newTop.length + i + 1,
              value: '0',
            }))
          ];
        }
      }

      setTop(newTop);
    }
  }, [result, typeId, planTypes]);

  let fullMessage: string | undefined = undefined;
  if (!dashboardLoading.dashboardTopDepartments && top.length === 0) {
    const planObject = planTypes.find((pt) => pt.id === typeId)?.plan_object;
    if (planObject) {
      fullMessage = `Нет планов "${planObject}" или сотрудников`;
    } else {
      fullMessage = "Нет планов, продаж или сотрудников";
    }
  }

  return {
    isPeriod,
    setIsPeriodState,
    typeId,
    planTypes,
    setTypeIdState,
    planName,
    fullMessage,
    top: top.slice(0,5),
    result: top,
    loading: dashboardLoading.dashboardTopDepartments,
    error: dashboardError.dashboardTopDepartments
  };
};

export default useTopDepartments;